<template>
  <v-container fluid>
    <h2>Patients</h2>
    <v-card-title>
      <div class="my-2">
        <v-btn color="primary" @click="newItem()" style="margin: 10px"
          >CREATE</v-btn
        >
        <v-btn v-if="loggedRoleId == 2" color="primary" @click="downloadCsv()"
          >EXPORT</v-btn
        >
      </div>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="SEARCH"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="patients"
      :search="search"
      item-key="name"
      class="elevation-1"
      :item-class="row_classes"
    >
      <template v-slot:[`item.startTime`]="{ item }">
        <span>{{
          item.startTime && item.endTime
            ? item.startTime + "-" + item.endTime
            : ""
        }}</span>
      </template>

      <!-- eslint-disable-next-line -->
      <template v-slot:[`item.updatedOn`]="{ item }">
        <span>{{ moment(item.updatedOn).format("MM-DD-YYYY") }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <!-- <v-icon   class="mr-2" @click="editRowClick(item)">mdi-pencil</v-icon> -->

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="editRowClick(item)"
              >mdi-pencil</v-icon
            >
          </template>
          <span>Edit Patient</span>
        </v-tooltip>

        <!-- <v-icon   @click="goToReport(item)">mdi-arrow-right-bold</v-icon> -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              style="margin-left: 20px"
              v-bind="attrs"
              v-on="on"
              @click="goToReport(item)"
              >mdi-file-document</v-icon
            >
          </template>
          <span>Go to Patient's report</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline"
              >{{ dialogItem.userId > 0 ? "EDIT " : "NEW " }} PATIENT</span
            >
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form" autocomplete="off">
                <v-row>
                  <!-- selectedRole.id refer to role id 3:siteAdmin 2:superAdmin 1:patient -->

                  <v-col cols="12" sm="6" md="6">
                    <div style="color: black">Patient Username</div>
                    <v-text-field
                      label="PI Last Name + Patient ID (ex. WELLS003)"
                      v-model="dialogItem.username"
                      :rules="requiredField"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <div style="color: black">Patient ID</div>
                    <v-text-field
                      label="Site ID + Patient ID (i.e. 001482)"
                      v-model="dialogItem.externalId"
                      :rules="requiredField"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <div style="color: black">iPad Provided</div>
                    <v-switch
                      v-model="dialogItem.providedIpad"
                      class="ma-2"
                      label="iPad Provided?"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <div style="color: black">iPad Serial #</div>
                    <v-text-field
                      label="iPad Serial Number"
                      :rules=[addressCheck]
                      v-model="dialogItem.ipadSerialNumber"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <div style="color: black">Active</div>
                    <v-switch
                      v-model="dialogItem.active"
                      class="ma-2"
                      label="Active?"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <div style="color: black">No Home Wifi?</div>
                    <v-switch
                      v-model="dialogItem.noHomeWifi"
                      class="ma-2"
                      label="No Home Wifi?"
                    ></v-switch>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <div style="color: black">Site Information</div>
                    <v-text-field
                      label="Site ID"
                      v-model="dialogItem.siteCode"
                      :disabled="loggedRoleId == 3"
                      :rules="requiredField"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <div style="color: black">Login Message</div>
                    <v-text-field
                      label="Message (optional)"
                      v-model="dialogItem.message"
                      hint
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <div style="color: black">Assessment Settings</div>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      hint="4 hours will be added to notification end time."
                      label="Assessment Start Time"
                      v-model="dialogItem.startTime"
                      required
                      :rules="[
                        () =>
                          !!dialogItem.startTime || 'This field is required',
                      ]"
                      @blur="dialogItemStartNotificationOnBlur"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      hint="Example 00:00"
                      label="Assessment End Time"
                      v-model="dialogItem.endTime"
                      required
                      :rules="[
                        () => !!dialogItem.endTime || 'This field is required',
                      ]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <div style="color: black">Assessment Assignments</div>
                    <v-combobox
                      v-model="dialogItem.selectedAssessmentTypes"
                      :items="items"
                      label="Select assessments assigned to patient"
                      multiple
                      item-text="name"
                      item-value="selectedAssessmentTypes"
                      chips
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false"
              >Close</v-btn
            >
            <!-- <div v-if="dialogItem.patientId > 0">
              <v-btn color="blue darken-1" text @click="updateItem()">update</v-btn>
            </div>
            <div v-else>
              <v-btn color="blue darken-1" text @click="updateItem()">Save</v-btn>
            </div>-->
            <v-btn color="blue darken-1" text @click="updateItem()">SAVE</v-btn>
            <!-- <v-btn color="blue darken-1" text @click="saveItem()">SAVE</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <div class="text-center">
      <!-- <v-btn dark color="orange darken-2" @click="snackbar = true">Open Snackbar</v-btn> -->
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="color"
        :top="y === 'top'"
      >
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </div>
  </v-container>
</template>
<script>
/* eslint-disable */
export default {
  data: () => ({
    snackbar: false,
    text: "REQUEST COMPLETE",
    timeout: 4000,
    y: "top",
    color: "error",
    search: "",
    patients: [],
    headers: [
      { text: "SYSTEM ID", value: "patientId" },
      { text: "USERNAME", value: "username" },
      { text: "PATIENT ID", value: "externalId" },
      { text: "SITE ID", value: "siteCode" },
      { text: "NOTIFICATION TIME", value: "startTime" },
      //{ text: "NOTIFICATION END TIME", value: "endTime" },
      { text: "UPDATED BY", value: "updatedBy" },
      { text: "UPDATED ON", value: "updatedOn" },
      { text: "Is Active", value: "active"},
      { text: "ACTIONS", value: "actions" },
    ],
    dialog: false,
    dialogItem: {
      patientId: 0,
      userId: 0,
      active: true,
      userRoleId: 1,
      username: "",
      externalId: "",
      siteCode: "",
      telephone: "",
      pin: "",
      startTime: "",
      endTime: "",
      message: "",
      selectedAssessmentTypes: [],
      providedIpad: false,
      ipadSerialNumber: "",
      noHomeWifi: false,
    },
    requiredField: [
      (v) => !!v || "This field is required",
      (v) => v.length >= 3 || "Minimum length is 3 characters",
    ],
    items: [],
    tempItem: {},
  }),
  methods: {
    addressCheck (v) {
       if(this.dialogItem.providedIpad === true) {
        return !!v || 'Required If iPad Provided.';
      }
      return true;
      },
    row_classes(item) {
      if (item.active == false) {
        return "gray"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
    editRowClick(item) {
      //OID30002
      this.tempItem = item;
      this.dialog = true;
      item.message = typeof item.message === "undefined" ? "" : item.message;
      item.startTime =
        typeof item.startTime === "undefined" ? "" : item.startTime;
      item.endTime = typeof item.endTime === "undefined" ? "" : item.endTime;
      this.dialogItem = JSON.parse(JSON.stringify(item));
      console.log(item);
    },
    newItem() {
      this.dialogItem = {
        patientId: 0,
        userId: 0,
        active: true,
        userRoleId: 1,
        username: "",
        externalId: "",
        siteCode: "",
        telephone: "",
        pin: "",
        startTime: "",
        endTime: "",
        message: "",
        selectedAssessmentTypes: [],
        noHomeWifi: false,
        providedIpad: false,
        ipadSerialNumber: "",
      };
      if (this.$store.getters.getRoleId == 3) {
        this.dialogItem.siteCode = this.$store.getters.getSiteCode;
      }

      this.dialog = true;
       this.$refs.form.resetValidation() 
      console.log("you click new assessment");
    },
    updateItem() {
      //OID30002
      if (this.$refs.form.validate()) {
        if (this.dialogItem.selectedAssessmentTypes != undefined) {
          this.dialogItem.selectedAssessmentTypes = this.dialogItem.selectedAssessmentTypes.filter(
            (x) => {
              return typeof x.assessmentTypeId != "undefined";
            }
          );
        }

        for (const elment of this.dialogItem.selectedAssessmentTypes) {
          const tempAssessmentType = this.items.find(
            (m) => m.assessmentTypeId == elment.assessmentTypeId
          );
          if (tempAssessmentType.questionCt == 0) {
            this.text =
              "There should be at least one question on  '" +
              tempAssessmentType.name +
              "'";
            this.color = "error";
            this.snackbar = true;
            return;
          }
        }

        this.$http
          .post(this.$store.getters.getBaseUrl + "patient", this.dialogItem)
          .then((result) => {
            if (this.dialogItem.patientId == 0) {
              this.patients.push(result.data);
            } else {
              this.tempItem.patientId = Number(result.data.patientId);
              this.tempItem.userId = Number(result.data.userId);
              this.tempItem.username = this.dialogItem.username;
              this.tempItem.externalId = this.dialogItem.externalId;
              this.tempItem.siteCode = this.dialogItem.siteCode;
              this.tempItem.active = this.dialogItem.active;
              this.tempItem.telephone = this.dialogItem.telephone;
              this.tempItem.message = this.dialogItem.message;
              this.tempItem.startTime = this.dialogItem.startTime;
              this.tempItem.endTime = this.dialogItem.endTime;
              this.tempItem.updatedOn = this.moment().format("MM-DD-YYYY");
              this.tempItem.updatedBy = this.$store.getters.getUsername;
              this.tempItem.selectedAssessmentTypes = this.dialogItem.selectedAssessmentTypes;
              this.tempItem.ipadSerialNumber = this.dialogItem.ipadSerialNumber;
              this.tempItem.providedIpad = this.dialogItem.providedIpad;
              this.tempItem.noHomeWifi = this.dialogItem.noHomeWifi;
            }
            this.$refs.form.reset()
            this.dialog = false;
            this.text = "REQUEST COMPLETE";
            this.color = "success";
            this.snackbar = true;
          })
          .catch((error) => {
            this.text = error.response.data;
            this.color = "error";
            this.snackbar = true;
          });
      }
    },
    saveItem() {
      console.log("saving item");
    },
    goToReport(item) {
      console.log(item);

      //   this.$router.push("/");
      var patientId = item.patientId == null ? -1 : item.patientId;
      //debugger
      this.$router.push({
        path: "assessmentReport",
        query: { patientId: patientId },
      });
    },
    dialogItemStartNotificationOnBlur() {
      // debugger;
      // console.log(
      //   this.moment("1-1-1111 " + this.dialogItem.startTime)
      //     .add({ hours: 4 })
      //     .format("HH:mm")
      // );
      this.dialogItem.endTime = this.moment(
        "1-1-1111 " + this.dialogItem.startTime
      )
        .add({ hours: 4 })
        .format("HH:mm");
    },
    downloadCsv() {
      //OID40001
      this.$http
        .request({
          url:
            this.$store.getters.getBaseUrl +
            "patientAssessmentType/?isReport=true",
          method: "GET",
          responseType: "blob",
        })
        .then((result) => {
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "patient.csv"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },
  },
  mounted() {
    // console.log("run mounted");
    //OID30001
    this.$http
      .get(this.$store.getters.getBaseUrl + "patientAssessmentType")
      .then((result) => {
        this.patients = result.data;
        //console.log(result.data);
      })
      .catch(function (error) {
        console.log("error " + error);
        alert("error" + error.response.data);
      });

    this.$http
      .get(this.$store.getters.getBaseUrl + "assessmentType")
      .then((result) => {
        // debugger
        let tempLista = result.data
          .map(function (e) {
            return {
              assessmentTypeId: Number(e.assessmentTypeId),
              name: e.name,
              active: e.active,
              questionCt: e.questionCt,
            };
          })
          .filter((assessment) => {
            return assessment.active === true;
          });
        this.items = tempLista;
      })
      .catch(function (error) {
        console.log("error " + error);
        alert("error" + error.response.data);
      });
  },
  computed: {
    loggedRoleId() {
      return this.$store.getters.getRoleId;
    },
  },
};
</script>

<style>
.gray {
  background-color: #d3d3d3;
}
</style>